import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject;

import React from 'react';
import styled from 'styled-components';
import { MicroConfig, Body, Micro } from '@vds-core/typography';
var ErrorTextWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "ErrorTextWrapper",
  componentId: "sc-13aeuon-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  margin-top: ", ";\n"])), function (_ref) {
  var errorLabelSpacing = _ref.errorLabelSpacing;
  return errorLabelSpacing;
});

var ErrorText = function ErrorText(props) {
  var errorLabelSpacing = props.errorLabelSpacing,
      bodyConfig = props.bodyConfig,
      typescale = props.typescale,
      errorText = props.errorText,
      error = props.error,
      success = props.success,
      successText = props.successText,
      color = props.color,
      inverted = props.inverted;
  var fontSize, LabelType;

  if (typescale === 'VDS') {
    fontSize = 'large';
    LabelType = Body;
  } else {
    fontSize = 'medium';
    LabelType = Micro;
  }

  return /*#__PURE__*/React.createElement("div", {
    role: "alert"
  }, /*#__PURE__*/React.createElement(ErrorTextWrapper, {
    errorLabelSpacing: errorLabelSpacing
  }, /*#__PURE__*/React.createElement(LabelType, {
    config: typescale === 'VDS' ? bodyConfig : MicroConfig,
    typescale: typescale,
    color: inverted ? color.white : color.black
  }, error ? errorText : success && successText)));
};

export default ErrorText;